import FormField from "../../forms/FormField";
import { Add } from "@mui/icons-material";
import {
  Box,
  Button,
  Grid,
  Typography
  } from "@mui/material";
import { newParticipantFormFields } from "../fieldsLists";
import { PossibleFormFieldValues } from "../../../interfaces/IForms";

interface ParticipantAddFormProps {
  formData: Record<string, PossibleFormFieldValues>;
  formErrors: Record<string, string[]>;
  disabled: boolean;
  onFieldChange: (key: string, value: PossibleFormFieldValues) => void;
  onSubmit: () => void;
  infoMessage: string | null;
  errorMessage: string | null;
}

/**
 * Formularz dodawania zawodnika
 * Zgodny z zasadą pojedynczej odpowiedzialności - tylko formularz
 */
export default function ParticipantAddForm({
  formData,
  formErrors,
  disabled,
  onFieldChange,
  onSubmit,
  infoMessage,
  errorMessage,
}: ParticipantAddFormProps) {
  return (
    <Box
      sx={{
        border: "1px solid #ddd",
        borderRadius: 1,
        p: 1,
        backgroundColor: "#fff",
        opacity: disabled ? 0.6 : 1,
        pointerEvents: disabled ? "none" : "auto",
      }}
    >
      {/* Pola formularza - zawsze w jednej linii */}
      <Grid container spacing={1} alignItems="flex-start">
        {newParticipantFormFields.map((field) => {
          const { key, ...fieldProps } = field;
          return (
            <Grid item xs={12} sm={6} md={4} lg={2} key={field.key}>
              <Box sx={{ minHeight: "80px", display: "flex", alignItems: "center" }}>
                <FormField
                  key={key}
                  {...fieldProps}
                  value={formData[field.key]}
                  onChange={(value) => onFieldChange(field.key, value)}
                  error={formErrors[field.key]?.length > 0}
                  helperText={formErrors[field.key]?.join(", ") || ""}
                  disabled={disabled}
                />
              </Box>
            </Grid>
          );
        })}

        {/* Przycisk zapisz - węższy */}
        <Grid item xs={12} sm={6} md={2} lg={1}>
          <Box sx={{ minHeight: "80px", display: "flex", alignItems: "center" }}>
            <Button
              variant="contained"
              size="small"
              startIcon={<Add />}
              onClick={onSubmit}
              disabled={disabled}
              sx={{
                backgroundColor: "#10b981",
                "&:hover": { backgroundColor: "#059669" },
                py: 1,
                px: 1.5,
                fontSize: "0.75rem",
                width: "100%",
                minWidth: "auto",
                "&:disabled": {
                  backgroundColor: "#9ca3af",
                },
              }}
            >
              Dodaj
            </Button>
          </Box>
        </Grid>
      </Grid>

      {/* Komunikaty - wewnątrz kontenera formularza */}
      {(infoMessage || errorMessage) && (
        <Box>
          {infoMessage && (
            <Typography color="success.main" sx={{ fontSize: "0.8rem" }}>
              {infoMessage}
            </Typography>
          )}
          {errorMessage && (
            <Typography color="error" sx={{ fontSize: "0.8rem" }}>
              {errorMessage}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
}
